export default function GoogleMapsAPILoader (accept, options = {}) {
    if (accept()) {
        return Promise.resolve();
    }
    return new Promise((resolve, reject) => {
        window.googleMapsAPILoad = window.googleMapsAPILoad || function () {
            for (const key in window.googleMapsAPILoad.callbacks) {
                if (window.googleMapsAPILoad.callbacks.hasOwnProperty(key)) {
                    window.googleMapsAPILoad.callbacks[key]();
                }
            }
        };
        window.googleMapsAPILoad.callbacks = window.googleMapsAPILoad.callbacks || [];
        window.googleMapsAPILoad.callbacks.push(() => {
            resolve();
        });
        let url = 'https://maps.googleapis.com/maps/api/js?';

        //Hardcoded JE client ID
        url += 'client=gme-justeat&';

        if (options.libraries && options.libraries.length > 0) {
            url += 'libraries=';
            options.libraries.forEach((library, index) => {
                url += library;
                if (index !== options.libraries.length - 1) {
                    url += ',';
                }
            });
            url += '&';
        }
        url += 'callback=googleMapsAPILoad';
        const script = document.createElement('script');
        script.type = 'text/javascript';
        script.setAttributeNode(document.createAttribute('async'));
        script.setAttributeNode(document.createAttribute('defer'));
        script.src = url;
        document.body.appendChild(script);
        setTimeout(() => {
            if (!accept()) {
                reject();
            }
        }, 5000);
    });
}
